var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-base',{staticClass:"button-float-menu",on:{"click":_vm.clickEvent}},[_c('image-base',{attrs:{"src":"/img/icon/manage/edit_button.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }